<template>
  <div class="page">
    <div style="height: 1.5rem;"></div>
    <quill-editor
      v-model="infoDetail.content"
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @change="onEditorChange($event)"
    ></quill-editor>
    <!-- <div v-html="infoDetail.content"></div> -->
    <div class="editTitleImg">
      <div class="editTitle">修改标题：</div>
      <textarea maxlength="80" v-model="infoDetail.title">{{
        infoDetail.title
      }}</textarea>
    </div>
    <div class="saveAll">
      <div class="saveAll_no" @click="backPage">取消修改</div>
      <div class="saveAll_yes" @click="saveAll">确认保存</div>
    </div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
const toolbarOptions = [
  ["bold", "italic", "underline", "strike", "image"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
  [{ indent: "-1" }, { indent: "+1" }],
  [{ size: [] }], // 配置字号
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
  [{ align: [] }], // 对齐方式-----[{ align: [] }]
  ["clean"], // 清除文本格式-----['clean']
];
import { Toast } from "vant";
import {
  getShare,
  getArticleDetailsNew,
  getUserInfo,
  postArticleEdit,
} from "@api/public";
let vm = null;
export default {
  name: "edit",
  components: {
    quillEditor,
  },
  data: function() {
    return {
      urlID: "",
      infoDetail: {
        content: "",
        title: "",
      },
      editorOption: {
        theme: "snow", // 默认主题
        placeholder: "请在这里输入", // 默认输入内容
        modules: {
          toolbar: toolbarOptions,
        },
      },
    };
  },
  created() {
    vm = this;
  },
  mounted: function() {
    this.urlID = this.$route.query.id;
    this.getArticleDetailsNew();
  },
  methods: {
    backPage() {
      const that = this;
      return that.$router.go(-1);
    },
    // 确认修改
    saveAll() {
      const that = this;
      const data = {
        aid: this.urlID,
        content: this.infoDetail.content,
        title: this.infoDetail.title,
      };
      postArticleEdit(data).then((res) => {
        if (res.status == 200) {
          Toast(res.msg);
          setTimeout(function() {
            return that.$router.go(-1);
          }, 1200);
        } else {
          Toast(res.msg);
        }
      });
    },
    getArticleDetailsNew() {
      const that = this;
      var data;
      if (this.urlID) {
        data = this.$route.query.id;
      }
      getArticleDetailsNew(data).then((res) => {
        if (res.data.head_info.ad_image) {
          res.data.head_info.ad_image = res.data.head_info.ad_image.split(",");
        }
        if (res.data.bottom_info.ad_image) {
          res.data.bottom_info.ad_image = res.data.bottom_info.ad_image.split(
            ","
          );
        }

        res.data.content = res.data.content.replace(
          /<img/gi,
          '<img style="max-width:100%;height:auto;display:inline-block;margin:10px auto;"'
        );
        this.infoDetail = res.data;
        console.log("this.infoDetail：", this.infoDetail);
        // this.setOpenShare();
      });
    },
    onEditorChange(e) {
      console.log("e:", e);
    },
    onEditorFocus(e) {
      console.log("e_Focus:", e);
    },
    onEditorBlur(e) {
      console.log("e_Blur:", e);
    },
  },
};
</script>

<style scoped>
/deep/.ql-toolbar {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  background-color: #fff !important;
  z-index: 9;
  height: 1.5rem;
}
.page {
  width: 100%;
  height: 100vh;
}
.quill-editor {
  position: relative;
}
.saveAll {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100px;
}
.saveAll_no {
  width: 3rem;
  line-height: 0.8rem;
  border: 0.02rem solid #999;
  color: #999;
  text-align: center;
  border-radius: 0.15rem;
}
.saveAll_yes {
  width: 3rem;
  line-height: 0.8rem;
  border: 0.02rem solid #ff410a;
  color: #fff;
  background-color: #ff410a;
  text-align: center;
  border-radius: 0.15rem;
}
.editTitleImg {
  margin: 0.5rem auto 0;
  padding: 0 0.3rem;
}
.editTitleImg .editTitle {
  font-size: 0.32rem;
  padding: 0.2rem 0;
}
.editTitleImg textarea {
  display: block;
  width: 100%;
  height: 2rem;
  background: #f0f0f0;
  padding: 0.2rem;
}
</style>
